import React from 'react';
import { PermissionCheckerClient } from './permission-checker-client.interface';

export const PermissionsContext = React.createContext<PermissionCheckerClient>(
  // We set initial value as null, but this context will be populated with PermissionCheckerClient API
  null as any as PermissionCheckerClient,
);
